// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"f0e236f6","213":"1b9e71cb","239":"1a90ae9c"}[chunkId] + ".chunk.js";
};